import dialogFormMixins from '@/mixins/dialogFormMixins.js'

import { getUserList, getReward } from '@/api/system.api.js'

import { mapActions, mapMutations } from 'vuex'

const defaultForm = {
  server_id: '',
  server_name: '',
  role_id: '',
  role_name: '',
}

export default {
  mixins: [dialogFormMixins],
  data() {
    return {
      dialogVisible: false,
      form: JSON.parse(JSON.stringify(defaultForm)),
      tips: '',
      roleList: [],
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    prizeList: {
      type: Array|Object,
      default: () => {
        return []
      }
    },
    type: {
      type: String,
      default: 'web'
    }
  },
  computed: {
    user() {
      return this.$store.getters.user
    },
  },
  watch: {
    visible: function (val) {
      this.dialogVisible = val

      if (val) this.getRoleInfo()
    },
  },
  methods: {
    ...mapActions(['getUserInfo']),
    ...mapMutations(['setTipsDialog', 'setBindDialog']),
    close() {
      this.$emit('update:visible', false)
    },
    getRoleInfo() {
      const params = {
        token: this.user.token,
        type: this.type,
        game: 'tc',
      }
      getUserList(params)
        .then((res) => {
          this.roleList = res.data
          this.roleList.unshift({
            serverId: '',
            serverName: '---请选择服务器---',
          })
        })
    },
    selectServer() {
      if (this.form.server_id === '') return false

      for (let i = 0; i < this.roleList.length; i++) {
        if (this.roleList[i].serverId == this.form.server_id) {
          this.form.role_id = this.roleList[i].roleId
          this.form.role_name = this.roleList[i].roleName
          this.form.server_name = this.roleList[i].serverName

          break
        }
      }
    },
    async handleBind(value) {
      this.checkForm()
      // 弹出提示窗
      if (this.tips != '') {
        this.setTipsDialog({ visible: true, tips: this.tips }) // 展示提示窗口
        return false
      }

      let count = 0;
      for (let i = 0; i < this.prizeList.length; i++) {
        if (this.prizeList[i].status != 0) continue

        const gift = this.prizeList[i]
        const params = {
          token: this.user.token,
          id: gift.id,
          roleId: this.form.role_id,
          serverId: this.form.server_id,
          type: gift.type,
        }
        getReward(params)
          .then((res) => {
            if (res.code != 0) {
              this.setTipsDialog({ visible: true, tips: res.msg })
            } else {
              this.setTipsDialog({ visible: true, tips: '领取成功' })
              this.$emit('afterGetReward')
              this.$emit('success')
            }
          })

        count++
      }
      if (count == 0) {
        this.setTipsDialog({ visible: true, tips: '没有可领取的奖励' }) // 展示提示窗口
      }

      this.close()
    },
    // 校验表单
    checkForm() {
      this.tips = ''
      if (this.form.server_id == '') {
        this.tips = '请选择服务器'
        return
      }
    },
  }
}